const lang = {
    header: {
        home: 'CSTR Identifier',
        home1: 'HOME',
        home2: 'SCIENCE DATA',
        home3: 'RESEARCHERS',
        home4: 'PROJECTS',
        home5: 'INSTITUTES',
        home6: 'MEMBERS',
        home7: 'ABOUT US',
        home9: 'EMPLOYMENT',
        home15: "News&Events",
        "home16": "COOPERATION",
        "home17": "Citation Query",
        "home18": "The RA code you wish to search for, e.g. 31253",
        "home19": "Accepted by international standard",
        "home20": "CSTR in IANA URI Schemes",
        "home21": "RESEARCHERS",
        "home22": "INSTITUTIONS",
        "home23": "Accepted by United Nations",
        "home24": "GERMPLASMS",
        "home25": "INSTRUMENTS",
        "home26": "Accepted by international organization",
        "home27": "PREPRINTS",
        "home28": "PATENTS",
        "home29": "Resource References",
        "home30": "Detail",
        "home31": "SPECIES",
        "home32": "CSTR PREFIX",
        "home33": "DISSERTATIONS",
        "dynamic": "New Data",
        "researchers": "Researchers",
        "title": "Together for Open Identifier",
        "subtitle": "Together for Open  Science",
        "facility": "LARGE RESEARCH INFRASTRUCTURES"

    },
    "organ": {
        "resourceName": "Resource Name、Organization"
    },
    "detail": {
        "detail16": "Creator"
    },
    main: {
        home1: 'Title, CSTR',
        homes: 'Name, ORCID',
        content1: 'Name',
        content2: 'Project Name',
        content3: 'organization',
        content4: 'Researchers',
        content5: 'Registrations',
        content6: 'Resolutions',
        content7: 'Provide Identity Services',
        content8: 'Identity Registration',
        content9: 'Identity Parsing',
        content10: 'Identity Search',
        content11: 'Sandbox Environment',
        content12: 'Allocate unique identifier, national Science and Technology Resource CSTR and International Science and technology Resource HANDLE.',
        content13: 'Permanent access to science and technology resources, CSTR, SDI, HANDLE and other original science and technology resources location links.',
        content14: 'Quality resource push, push to international ORCID and other resources.',
        content15: 'Provides an identity registration test environment for quick use.',
        content16: 'Sharing academic achievements',
        content17: 'Share academic achievements quickly through the logo, and obtain statistical data for monitoring the dissemination of academic achievements.',
        content18: 'Branch management',
        content19: 'Supports redistribution, allocates code to branches, supports branch resource review and aggregation, etc.',
        content20: 'Unique authentication of scientific resources',
        content21: 'The allocation of s&T resources has a national standard\'ID card\', which is included in the national s&T resource system.',
        content22: 'Publisher',
        content23: 'Retrieve',
        content24: 'Found for you',
        content25: 'records',
        content26: 'Application Scenarios',
        content27: 'No Data Available',
        "content28": 'Title',
        "content29": "Title: "
    },
    "researchDetail": {
        "research1": "Basic Information",
        "research2": "Data Center: ",
        "research3": "Affiliation: ",
        "research4": "Release Date: ",
        "research5": "Type:",
        "research6": "Keywords: ",
        "research7": "Subject: ",
        "research8": "URL: ",
        "research9": "Abstract"
    },
    "apply": {
        "apply1": "Your form has been successfully submitted.",
        "apply2": "This email already exists.",
        "apply3": "System busy, please try again later."
    },
    search: {
        search1: 'Publication Date',
        search2: 'Publisher',
        search3: 'Description',
        search4: 'Search',
        "search6": "Show",
        "search7": "Fold",
        "search8": "Keywords: ",

    },
    "resolve": {
        "resolve1": "CSTR Identification Platform",
        "resolve2": "CSTR Identification Platform aims to promote establishing a global science and technology resource identification architecture, which is able to tracing the global influence, cross-disciplinary, cross-regional and cross-platform, to realize the rapid positioning and acquisition worldwide, and be used as the digital base for open science, contributed to the scientific research innovation.",
        "resolve3": "1. Registration Service",
        "resolve4": "Through the registration of science and technology resource identifiers and metadata, the published scientific and technical resources are made more discoverable and accessible.",
        "resolve5": "2. Resolution Service",
        "resolve6": "Convenient enquiry and search services are provided by using scientific and technical resource identifiers, keywords and metadatas as inputs.",
        "resolve7": "3. Associated Services",
        "resolve8": "Linking papers to authors, papers to resources, and research processes and results data in a vast network of associations through scientific and technical resource markers.",
        "resolve9": "4. Data Service",
        "resolve10": "Provide data services of multi-dimensional statistical analysis such as total resources registrations, resolutions and queries.",
        "resolve11": "is initialed in 2016 based on the National Standard GB/T 32843—2016“Science and technology resource identification”, providing unique identification service for global scientific data, papers, scientific institutions, researchers, scientific instruments, patents and other scientific and technological resources. CSTR is also accepted as the international standard, such as IANA., etc. ",
        "resolve12": "It's simple to use CSTR identifier:",
        "resolve13": ""
    },
    nsf: {
        "nsf1": "Affiliation: ",
        "nsf2": "Types:  ",
        "nsf3": "NSF Org: ",
        "nsf4": "Country: ",
        "nsf5": "Awardee: ",
        "nsf6": "Date:",
        "nsf7": "Country: ",
        "nsf8": "Award Type: ",
        "nsf9": "NSF Org: ",
        "nsf10": "Abstract: "
    },
    "newData": {
        "newData1": "Works",
        "newData2": " Associated Relationship ",
        "newData3": " Statistics ",
        "newData4": " Works ",
        "newData5": "Citations",
        "newData6": " Resolutions ",
        "newData7": "Views",
        "newData8": " Role/Title ",
        "newData9": " Membership ",
        "newData10": " Role/Title：",
        "newData11": "Award",
        "newData12": " Award Name：",
        "newData13": " Collaborative Researchers ",
        "newData14": " Most Authors for a Single Article ",
        "newData15": " Cooperation ",
        "newData16": " Cooperative Journals ",
        "newData17": " Conference ",
        "newData18": " Partner Journals List",
        "newData19": " Works List ",
        "newData20": " Abstract：",
        "newData21": " Source：",
        "newData22": " Author：",
        "newData23": " No Data Set Data Available ",
        "newData24": " Total Funding Projects ",
        "newData25": " National Key Research and Development Program ",
        "newData26": " Chinese Academy of Sciences program ",
        "newData27": " National Natural Science Foundation of China (NSFC) ",
        "newData28": " Associated Outcomes ",
        "newData29": " Sponsors List ",
        "newData30": " Associated Outcomes ",
        "newData31": " Publication Date：",
        "newData32": " No Patent Data Available ",
        "newData33": " No Journal Articles Available ",
        "newData34": " Statistics ",
        "newData35": " Total Number of Works ",
        "newData36": " Journal Papers ",
        "newData37": " Citations ",
        "newData38": " Highly Influential Citations ",
        "newData39": " Name：",
        "newData40": " Works List ",
        "newData41": " Trend of Personal Views in the Past Seven Days ",
        "newData42": " Top 10 Collaborative Researchers",
        "newData43": " Journal Collaboration Ranking ",
        "newData44": "No.",
        "newData45": "Funding ",
        "newData46": "Grant Number",
        "newData47": "Type",
        "newData48": "Date",
        "newData49": "Works",
        "newData50": "Trends in the Number of Sponsored Projects per Year",
        "newData51": "Journal Title: ",
        "newData52": "Cited CSTR",
        "newData53": "DOI",
        "newData54": "Cited Journal",
        "newData55": "Journal Impact Factor",
        "newData56": "Title"
    },
    nsfdetail: {
        "nsfdetail1": "Project Information: ",
        "nsfdetail2": "Name: ",
        "nsfdetail3": "Date: ",
        "nsfdetail4": "Funder:  ",
        "nsfdetail5": "Total Intended Award Amount: ",
        "nsfdetail6": "Award Instrument: ",
        "nsfdetail7": "Initial Amendment Date: ",
        "nsfdetail8": "Latest Amendment Date: ",
        "nsfdetail9": "Abstract: ",
        "nsfdetail10": "NSF Org: ",
        "nsfdetail11": "Org: ",
        "nsfdetail12": "Org Abbreviation: ",
        "nsfdetail13": "Department: ",
        "nsfdetail14": "Department Abbreviation: ",
        "nsfdetail15": "Program Manager: ",
        "nsfdetail16": "Program Manager: ",
        "nsfdetail17": "Email ",
        "nsfdetail18": "Tel: ",
        "nsfdetail19": "Title: ",
        "nsfdetail20": "Other Names: ",
        "nsfdetail21": "Tel: ",
        "nsfdetail22": "Primary Place of Performance: ",
        "nsfdetail23": "Org Name: ",
        "nsfdetail24": "Country: ",
        "nsfdetail25": "City: ",
        "nsfdetail26": "Org Code: ",
        "nsfdetail27": "Address ",
        "nsfdetail28": "Awardee: ",
        "nsfdetail29": "Org Name: ",
        "nsfdetail30": "Country: ",
        "nsfdetail31": "City: ",
        "nsfdetail32": "Address: ",
        "nsfdetail33": "Org Code: ",
        "nsfdetail34": "DUNS: ",
        "nsfdetail35": "Partner DUNS: ",
        "nsfdetail36": "Award Amount: "
    },
    "guide": {
        "guide0": "The CSTR Citation Guide is designed to provide users with a uniform citation format for displaying CSTR in order to improve the quality of data associated with CSTR and papers.",
        "guide1": "CSTR Citation Guide",
        "guide2": "CSTR Citation Format",
        "guide3": "Citation CSTR in the following scenarios",
        "guide4": "1.CSTR in Reference",
        "guide5": "2.CSTR in Resource page",
        "guide6": "CSTR is displayed directly on the page. E.g.",
        "guide7": ",and add a URL for CSTR resolution.",
        "guide8": "By pasting the code below into the page of the corresponding resource",
        "guide9": "Copy",
        "guide10": "click on the CSTR and the page will be redirected to the corresponding page.",
        "guide11": "The platform also supports adding CSTR 2D barcode to the resource page, so as to scan CSTR 2D barcode to access the corresponding page.",
        "guide12": "The platform provides a 2D barcode generation service, which can be automatically generated by embedding the code below into the resource page.",
        "guide13": "注：",
        "guide14": "When using the code, please note that the CSTR after the code URL should be replaced with the corresponding identifier on the resource page.",
        "guide15": "The platform offers two styles of 2D barcode. When style=1 in the submission parameter, style 1 is used to generate 2D barcode, and when style = 0, style 2 is used to generate 2D barcode.",
        "guide16": "Style 1",
        "guide17": "Style 2",
        "guide18": "3. Integrated Resolution Service",
        "guide19": "The platform provides an integrated resolution service, which enables resolving the local identifier by pasting the code below into the corresponding resource page.",
        "guide20": "CITATION GUIDE"
    },
    detail: {
        detail1: 'Basic Information',
        detail2: 'Registration Authority',
        detail3: 'Identifier',
        detail4: 'Release Date',
        detail5: 'Sharing Path',
        detail6: 'Share Scope',
        detail7: 'Link Address',
        detail8: 'Submit Insitution',
        detail9: 'Insitution',
        detail10: 'Address',
        detail11: 'Postcode',
        detail12: 'Email',
        detail13: 'Registration Authority',
        detail14: 'Insitution',
        detail15: "No Data Available",
        "detail16": "Creator",
        detail17: "Organization",
        "detail18": "Organization Identifier: ",
        "detail19": "Institution: ",
        "detail20": "CSTR:"
    },
    "result": {
        "paper": "PAPER",
        "paper2": "Title(Chinese)",
        "paper3": "Title",
        "paper4": "Published Journal",
        "paper5": "Keywords",
        "paper6": "Keywords",
        "paper7": "Original Article Address",
        "paper8": "Source",
        "paper9": "References",
        "papers10": "Title",
        "paper11": "Published Year",
        "paper12": "Authors",
        "papers13": "Publisher: ",
        "papers14": "Author Info",
        "paper15": "Funding Information",
        "content": "NSTI（National Science and Technology infrastructure） Special Project 'Development of common technical standards for the construction of scientific and technological resources identification system'",
        "content1": "CAS （Chinese Academy of Sciences）informatization Special Project 'scientific data center system construction of CAS'",
        "content2": "Our results",
        "content3": "Our mission",
        "content4": "Team introduction",
        "content5": "IANA（The Internet Assigned Numbers Authority）is responsible for the global coordination of the DNS Root, IP addressing, and other Internet protocol resources. The “Uniform Resource Identifier (URI) Schemes” is one of the most important identifier resources standard, involving doi, dns., etc. The CSTR is accepted by this international standard.",
        "content6": "CSTR is accepted by ORCID identifier types",
        "content7": "CSTR in ORCID",
        "content8": "The cooperation with Food and Agriculture Organization of the United Nations",
        "content9": "CSTR in GLISTtest",
        "content10": "November 20, 2021",
        "content11": "Institute Links",
        "content12": "CSTR Prefix:",
        "content13": "Members",
        "content14": "Outputs",
        "content15": "Please enter the correct RA Code",
        "content16": "Sorry, the RA Code cannot be empty",
        "content17": "National standard",
        "content18": "OUR SERVICE",
        "content19": "COOPERATION",
        "content20": "The Food and Agriculture Organization (FAO) is a specialized agency of the United Nations that leads international efforts to defeat hunger. The Global Information System for PGRFA is one of the most important databases. The CSTR is accepted by this international database.",
        "content21": "ORCID, which stands for Open Researcher and Contributor ID, is a global, not-for-profit organization. It supports the most popular identifiers, such as doi and pmid. The CSTR is accepted by ORCID.",
        "content22": "Accepted by international repository",
        "content23": "Harvard Dataverse is an open online repository developed by Harvard University to share, preserve, cite, explore and analyze research data. It offers more than 75,000 data sets and 350,000 files, which are widely used by researchers all over the world. The CSTR is accepted by this international database.",
        "content24": "ePIC is a consortium of EU partners based on the Handle System (TM, https://www.handle.net/), for the allocation and resolution of persistent identifiers (PID). CNIC is a member of the ePIC consortium and the only agent for Handle 21  in China.",
        "content25": "DataCite is a global community that makes research more effective with metadata that connects research outputs and resources – from samples and images to data and preprints, by enabling the creation and management of persistent identifiers (PIDs), integrate services to improve research workflows, and facilitate the discovery and reuse of research outputs and resources. CNIC is a member of DataCite, helping data centers and researchers register DOIs.",
        "content26": "The International Telecommunication Union (ITU) is the United Nations agency in charge of information and communication technology, and is responsible for formulating global telecommunications standards. CNIC has participated in the offline and online meetings of ITU-T SG2 and SG20 for many times, and invested and explored in the application field of the combination of Internet of Things logo technology and new technology.",
        "content27": "Crossref is a non-profit organization founded in 2000 and an official digital object identifier (DOI) Registration Agency of the International DOI Foundation. Its aim is to achieve persistent cross-publisher citation links in online academic journals. Crossref interlinks a variety of content types, including journals, books, conference proceedings, technical reports, and data sets, making research objects easy to find, cite, link, evaluate, and reuse.",
        "content28": "RAiD (Research Activity Identifier) provides a persistent, unique, resolvable identifier for research projects and certification as an ISO standard for project identification, managed and serviced by the Australian Research Data Commons (ARDC).",
        "content29": "Identifiers.org is created and managed by the European Bioinformatics Institute (EMBL-EBI). EMBL-EBI are part of the European Molecular Biology Laboratory (EMBL), an intergovernmental research organisation funded by over 20 member states, prospect and associate member states. The Identifiers.org resolution service supports fundamental identifiers such as DOI, ORCID, ROR, and now also supports CSTR.",
        "content30": "Cooperation Partners",
        "content31": "Food and Agriculture Organization",
        "content32": "International Telecommunication Union",
        "content33": "Global Open Science Cloud (GOSC, https://goscloud.net/) aims to co-design and co-build a cross-continental federated e-infrastructure and virtual research environment for global cooperation and open science by harmonized policies, interoperable protocols, transparent services and sustained mechanism. ",
        "content34": "STM（International Association of Scientific, Technical and Medical Publishers) is the standard bearer for the academic publishing industry, working with its members to advance trusted research worldwide. STM champion innovation across academic research, and committed to ensuring that the great discoveries of our time are communicated with pinpoint accuracy, clarity and integrity."

    },
    keywords: {
        "keywords1": "Science Data",
        "keywords14": "PUBLICATIONS",
        "keywords17": "PATENTS",
        "keywords20": "Patents",
        "keywords25": "Dataset",
        "keywords26": "Publications",
        "species": "Species",
        "priprent": "Priprent"
    },
    people: {
        people1: 'Works',
        people2: 'Citation',
        people3: 'Biography',
        people4: 'Employment',
        people5: 'Organization ID type',
        people6: 'Country',
        people7: 'Organization ID',
        people8: 'Department',
        people9: 'Qualification',
        people10: 'City',
        people11: 'Role/Title',
        people12: 'Works',
        people13: 'Publisher',
        people14: 'Identifier type',
        people15: 'Resource Identifier',
        people16: 'Education',
        people16: 'More',
        People17: 'Works',
        people18: 'Date',
        people19: 'Role/Title',
        people20: 'Funding',
        people21: 'Number',
        people22: 'Funding Type',
        people23: 'Release date',
        people24: 'Associated Works',
        people25: 'Relationships',
        people26: 'Keywords',
        people27: 'Date',
        people28: 'Works',
        people29: 'Citation'
    },
    "ror": {
        "ror1": "Name ",
        "ror2": "Types: ",
        "ror3": "Status: ",
        "ror4": "Country: ",
        "ror5": "Established: ",
        "ror6": "Status: ",
        "ror7": "Website: ",
        "ror8": "Types: ",
        "ror9": "Name: ",
        "ror10": "Types",
        "ror11": "Established",
        "ror12": "Country ",
        "ror13": "Website",
    },
    "rorDetail": {
        "rorDetail1": "Related Identifiers",
        "rorDetail2": "Country: ",
        "rorDetail3": "Related Organizations",
        "rorDetail4": "Relationships:",
        "rorDetail5": "Related Types:",
        "rorDetail6": "Name："
    },
    "prefix": {
        "prefix1": "Query Results",
        "prefix2": "CSTR Prefix: ",
        "prefix3": "Type: ",
        "prefix4": "Status: ",
        "prefix5": "Registered On: ",
        "prefix6": "Website: ",
        "prefix7": "Name: ",
        "prefix8": "This prefix could not be found, please contact cstr@cnic.cn",
        "prefix9": "The prefix is incorrect"
    },
    peopleDetail: {
        "peopleDetail1": "Basic Information",
        "peopleDetail2": "ORCID original parsing page",
        "peopleDetail3": "Name ",
        "peopleDetail4": "Other Names ",
        "peopleDetail5": "country:",
        "peopleDetail6": "Personal URL  ",
        "peopleDetail7": "Basic Information",
        "peopleDetail8": "No Data Available",
        "peopleDetail9": "Associated Author",
        "peopleDetail10": "Works",
        "peopleDetail11": "Citation",
        "peopleDetail12": "No Data Available",
        "peopleDetail13": "Biography",
        "peopleDetail14": "Introduction ",
        "peopleDetail15": "Employment",
        "peopleDetail16": "Organization ID Type",
        "peopleDetail17": "Country ",
        "peopleDetail18": "Organization ID ",
        "peopleDetail19": "Department: ",
        "peopleDetail20": "Funding Plan (Action Type): ",
        "peopleDetail21": "Invited Position",
        "peopleDetail22": "Qualification",
        "peopleDetail23": "Organization ",
        "peopleDetail24": "City: ",
        "peopleDetail25": "Role/Title",
        "peopleDetail26": "Education",
        "peopleDetail27": "Funding",
        "peopleDetail28": "Title of Funded Project",
        "peopleDetail29": "Organization",
        "peopleDetail30": "Grant Number",
        "peopleDetail31": "Funding Type ",
        "peopleDetail33": "Works",
        "peopleDetail34": "Publisher",
        "peopleDetail35": "Identifier Type:",
        "peopleDetail36": "Identifier Value",
        "peopleDetail37": "No Open Data Available",
        "peopleDetail38": "Research Interest",
        "peopleDetail39": "More",
        "peopleDetail40": "Source",
        "peopleDetail41": "Release Date",
    },
    "research": {
        "research1": "Affiliation",
        "research2": "Type",
        "research3": "Content Type",
        "research4": "Subject",
        "research5": "Description",
        "research6": "URL"
    },
    organ: {
        organ1: 'Release Date',
        organ2: 'Affiliation',
        organ3: 'Type',
        organ4: 'Content Type',
        organ5: 'Subject',
        organ6: 'Description',
        organ7: 'URL',
        organ8: 'Subject',
        organ9: 'Keywords',
    },
    "member": {
        "member1": "Becoming a member includes three steps:",
        "member2": "1. Prefix Application",
        "member3": "Please send an email to cstr@cnic.cn for inquiries",
        "member31": "",
        "member32": ".",
        "member4": "2. Become a Member",
        "member5": "After receiving the application, the feedback will be sent within 3-5 working days. You will receive the CSTR prefix. ",
        "member6": "3.Identifier Registration",
        "member7": "After the approval, we will provide the operation manual to help you get familiar with the relevant processes. If you have any further questions, please do not hesitate to contact ",
        "member8": "Prefix Application",
        "member9": "Become a member",
        "member10": "Identifier Registration",
        "member11": "Login",
        "member12": "Prepare Metadata",
        "member13": "Registration",
        "member14": "Identifier Management",
        "member15": "Step 1",
        "member16": "Step 2",
        "member17": "Step 3",
        "member18": "Step 4",
        "member19": "cstr@cnic.cn",
        "member20": ".",
        "member21": "Scientific Data Center"
    },

    "grid": {
        "grid1": "Aliases ",
        "grid2": "Acronyms  "
    },
    "online": {
        "online1": "Online Application",
        "online2": "Organization",
        "online3": "Full Name",
        "online4": "Email",
        "online5": "Submit",
        "online6": "Cancel",
        "online7": "Organization Name",
        "online8": "Enter your Name",
        "online9": "Enter your Email",
        "online10": "Please Enter the Correct Email Address"
    },
    eu: {
        eu1: 'EU',
        eu2: 'NSF',
        eu3: 'Date',
        eu4: 'Project Abbreviation',
        eu5: 'Status',
        eu6: 'Country',
        eu7: 'Objective',
        eu8: 'Abbreviation',
        eu9: 'Funding plan',
        eu10: 'Total Project Cost',
        eu11: 'Board of Directors',
        eu12: 'Contact',
        eu13: 'Project Organization',
        eu14: 'Total Amount of Award',
        eu15: 'Types',
        eu16: 'Name',
        eu17: 'Abbreviated',
        eu18: 'Department',
        eu19: 'Department Abbreviation',
        eu20: 'Program Manager',
        eu21: 'Program Manager',
        eu22: 'Email',
        eu23: 'Tel',
        eu24: 'Associated Person',
        eu25: 'More',
        eu26: 'Primary Place of Performance',
        eu27: 'Org Name',
        eu28: 'Country',
        eu29: 'Org Code',
        eu30: 'Address',
        eu31: 'Awardee',
        eu32: 'Address'
    },

    "news": {
        "news1": "News",
        "news2": "Latest News",
        "news3": "Details",
        "news4": "Announcement",
        "news5": "Technology Communication",
        "news6": "Service Effectiveness",
        "news7": "Source:",
        "news8": "Computer Network Information Center of Chinese Academy of Sciences",
        "news9": "Publication Time: "
    },
    "newList": {
        "newList1": "Chinese Academy of Sciences Computer Network Information Center was invited to attend the annual meeting of Medical Device IoT Management Professional Committee",
        "newList2": "On November 21-23, 2019, the annual meeting of the Medical Device Internet of Things Management Professional Committee and the Medical Device Unique Identification Innovation Application Forum was held in Xiamen, Fujian. Representatives of national and local regulatory departments, medical institutions, production and distribution enterprises and relevant IT enterprises and other industry representatives attended this meeting, totaling more than 300 people. Han Hua, Secretary of the Party Committee of Computer Network Information Center, was invited to lead a team to attend this meeting.",
        "newList3": "Domestic and foreign mainstream identification standard specification interpretation",
        "newList4": " In recent years, identification technology has not only supported new technology fields such as industrial Internet and Internet of Things, but also has been widely used in the new generation of scientific research informatization fields such as science and technology resource sharing and scientific data opening. We focus on combing and interpreting these domestic and foreign mainstream identification systems from standard specifications, so that scholars and practitioners can understand and learn identification technology more systematically.",
        "newList5": "Computer Network Information Center of Chinese Academy of Sciences participates in the 14th Plenary Meeting of the International Research Data Alliance (RDA)",
        "newList6": "On October 23, 2019, the 14th plenary meeting of the International Research Data Alliance (RDA) was held in Helsinki, Finland, with more than 600 data scientists and researchers from all over the world. Professor Heikki Mannila, President of the Academy of Finland, gave a speech entitled 'Bigdata, small data, open data'. In order to strengthen the international exchange and cooperation in the field of scientific data labeling, a delegation from the Computer Network Information Center of the Chinese Academy of Sciences attended the conference.",
        "newList7": "Computer Network Information Center of Chinese Academy of Sciences Wins Bid for 2019 Industrial Internet Innovation Development Project",
        "newList8": "Recently, in the fierce bidding competition for the 2019 Industrial Internet Innovation and Development Project, the Computer Network Information Center of the Chinese Academy of Sciences stood out with its strong scientific research and innovation strength and successfully won the 2019 Industrial Internet Innovation and Development Project - Identification Resolution Public Service Support Platform Project (independent winning bid) and Industrial Internet Identification Resolution Secondary Node Platform (Comprehensive Application Service Platform) Subcontract 1 Project (joint winning bid)."
    },
    "newDetail": {
        "newDetail1": "Views:",
        "newDetail2": "On November 21-23, 2019, the annual meeting of the Medical Device Internet of Things Management Professional Committee and the Medical Device Unique Identification Innovation Application Forum was held in Xiamen, Fujian. Representatives of national and local regulatory departments, medical institutions, production and distribution enterprises and relevant IT enterprises and other industry representatives attended this meeting, totaling more than 300 people. Han Hua, Secretary of the Party Committee of Computer Network Information Center, was invited to lead a team to attend this meeting.",
        "newDetail3": " At the meeting, Dong Qian, director of the Medical Administration Bureau of the National Health Care Commission, and Guo Yuanyuan, director of the National Drug Administration Information Center, gave a report on the theme of 'recent medical supplies management policy interpretation' and 'the progress of the unique identification system for medical devices', and the leaders of Fujian Provincial Medical Insurance Bureau and Beijing Municipal Medical Bureau also explained the new industry policy in their departments.",
        "newDetail4": "Computer Network Information Center of Chinese Academy of Sciences made a keynote speech titled 'Application of identification Technology in Food Traceability', which introduced in detail the current application of marking technology in food traceability, and the centralized traceability system is difficult to guarantee the data due to the numerous links involved, complex management of traceability data and unified standards. The food traceability system involves many links, complex traceability data management, unified standards, and centralized traceability system is difficult to guarantee the safety and control of data.Identification technology is one of the core technologies in the process of food traceability system construction. Using the cross-platform interoperability feature of identification technology, it can effectively promote the integration and reuse of data from different links in the whole life cycle of food production, and promote the rapid development of food traceability applications.",
        "newDetail5": " In addition, representatives from China Article Coding Center, Fudan University, PLA General Hospital, The First Affiliated Hospital of Sun Yat-sen University, Subei People's Hospital, Shanghai Minimally Invasive Medical Devices (Group) Co. Ltd. also shared their experiences from different perspectives on identification technology. "
    },
    footer: {
        footer1: ' Beijing ICP NO. 09112257-127',
        footer2: 'Computer Network Information Center, Chinese Academy of Sciences',
        footer3: 'Email',
        footer4: 'All Rights Reserved',
        footer5: '',
        footer7: 'Computer Network Information Center, Chinese Academy of Sciences',
        "footer8": "Request Address",
        "footer9": "Environment",
        "footer10": "HTTPS Request Address",
        "footer11": "Method",
        "tip": "The {res_name} in the request parameter is the identification metadata template type, with a value range",
        "footer6": "Supported by: ",
        "footer273": "Identifier type",
        "footer268": "Identifier value",
        "footer263": "Alternative identifiers",
        "footer278": "Related Identifiers",
        "footer11": "For Users",
        "footer15": "Public Request Parameters",
        "footer16": "Parameter",
        "footer17": "Type",
        "footer18": "Required ",
        "footer19": "Maximum Length",
        "footer20": "Type",
        "footer24": "Yes",
        "footer21": "Example Value",
        "footer30": "Yes",
        "footer36": "Description",
        "footer56": "No",
        "footer21": "Example Value",
        "footer22": "For CSTR identification registration, supporting metadata templates for scientific data, academic papers, patents, preprints, etc. If you have any questions, please email cstr@cnic.cn.",

    },
    "api": {
        "science": "science data",
        "journal": "journal article",
        "patent": "patent",
        "software": "software copyright",
        "preprints": "preprint",
        "instrument": "instrument",
        "diss": "dissertation",
        "parameter": "Parameter Details",
        "example": "Parameter examples",
        "register": "Registration Success",
        "bad": "Bad Request",
        "error": "Internal Server Error",
        "check": "Please check the request parameter format",
        "verify": "Please verify the failure message against the returned parameters and re-initiate the request"
    },
    "quote": {
        "quote1": "Citation Query",
        "quote2": "Description:",
        "quote3": "Citations:",
        "quote4": "Click to view",
        "quote5": "Score",
        "quote6": "Highest Citation",
        "quote7": "Citation Query",
        "quote8": " Update time: ",
        "quote9": "Name: ",
        "quote10": "Pageviews",
        "quote11": "Parsing mount",
        "quote12": "Average citation",
        "quote13": "High quality reference",
        "quote14": "Please enter CSTR to query",
        "quote15": "Citation ranking",
        "quote16": "Patent: "
    },
    "newTip": {
        "newTip1": "Click to resolve CSTR",
        "newTip2": "Applicant:",
        "newTip3": "Inventor:",
        "newTip4": "Invention Title:",
        "newTip5": "Publication Date：",
        "newTip6": "Application No.:",
        "newTip7": "Application Date:",
        "newTip8": "Publication No.:",
        "newTip9": "Publication Date:",
        "newTip10": "Applicant:",
        "newTip11": "Inventor:",
        "newTip12": "Title、CSTR",
        "newTip13": "Registrant",
        "newTip14": "Description: ",
        "newTip15": "CSTR Prefix",
        "newTip16": "Sorry, the prefix you entered is not in the correct format",
        "newTip17": "Type: ",
        "newTip18": "More",
        "newTip19": "Who owns this CSTR Prefix?",
        "newTip20": "You can use Search by CSTR prefix to view basic information about the organization to which prefix belongs, including the name, website, description that the organization has and status information."
    },
    "prefix": {
        "prefix1": "Query Results",
        "prefix2": "Prefix: ",
        "prefix3": "Type: ",
        "prefix4": "Status: ",
        "prefix5": "Registered On: ",
        "prefix6": "Organization Website: ",
        "prefix7": "Registration Authority Name: ",
        "prefix8": "Sorry, no information about this prefix has been resolved yet."
    },
    "diss": {
        "diss1": "Degree Conferring Institutions:",
        "diss2": "Training Unit:",
        "diss3": "URL:",
        "diss4": "Tutor:",
        "diss5": "Affiliation",
        "diss6": "References",
        "diss7": "Similar Articles",
        "diss8": "Publication Types",
        "diss9": "Copied Successfully",
        "diss10": "Source: ",
        "diss11": "Resolutions: ",
        "diss12": "Newest Cited",
        "diss13": "Newest Registrations",
        "diss14": "Newest Resolutions",
        "diss15": "Most Cited",
        "diss16": "Cited by",
        "diss17": "MORE",
        "diss18": "Title",
        "diss19": "Institution",
        "diss20": "Keywords",
        "diss21": "Identifier",
        "diss22": "Registration Date",
        "diss23": "Resolution Date",
        "diss24": "Cited Date",
        "diss25": "Source",
        "diss26": "Resolutions",
        "diss27": "Institution/Author",
        "diss28": "Citations",
        "diss29": "Identifier",
        "diss30": "BIOINFORMATICS",
        "diss31": "cited: "

    },
    "person": {
        "professional": "Position",
        "organ": "Organization",
        "paperTotal": "Papers",
        "quoteTotal": "Citations",
        "study": "Research Interests",
        "static": "Metrics",
        "scanCode": "Scan to Resolve",
        "codeFollow": "Scan to Share",
        "allYears": "By Year",
        "allTypes": "By Citation",
        "sort": "Sort",
        "resolve": "Resolution",
        "regions": 'Category Quartile',
        "database": "Collection",
        "iview": "Views",
        "quote": "Citations",
        "search": "Search",
        "paper1": "Journal article",
        "paper2": "Conference proceeding",
        "paper3": "Dissertation",
        "creatorIdentifier": "Creator name identifier",
        "homepage": "Personal Page",
        "recommen": "The UNESCO Recommendation on Open Science"
    },
    "apply": {
        "apply1": "Your form has been successfully submitted.",
        "apply2": "The graphic captcha is incorrect.",
        "apply3": "System busy, please try again later.",
        "apply4": "Change",
        "apply5": "Verification Code",
        "apply6": "Enter your Verification Code",
        "apply7": "Code"
    },
    "message": {
        "message": "The search cannot be empty",
        "active": "Active",
        "active1": "Active",
        "active2": "Meeting Notice"
    },
    "meeting": {
        "title": "The International workshop on Open Science Identifier Successfully Held in Beijing"
    },
    "notice": {
        "title": "The International workshop on Open Science Identifier",
        "time": "2023 October 17-18",
        "address": 'Chinese Academy of Sciences Informatization Building and Online',
        "register": 'Register here',
        "intro": 'Event Description',
        "cooperation": "Cooperation Unit",
        "description": 'DataCite and Common Science and Technology Resource Identifier (CSTR) are co-organizing an in-person workshop in Beijing, China, bringing together stakeholders in the Open science and research data management communities to explore the role of persistent identifiers (PIDs) in local and global contexts, demonstrate implementation cases, and discuss recent developments in the global PID ecosystem.',
        'topic': "Event Topic",
        "topicDescripe": 'The workshop will highlight the value of PIDs in the context of PID history and how PID services, tools, and platforms will help to realize the FAIR principle. We will also guide a discussion on the future development trends for PIDs and how to make PIDs more active, stable, and interoperable, with reference to the ongoing PID-related work in the RDA.',
        "topic1": "Topic 1",
        "topic2": "Topic 2",
        "topic3": "Topic 3",
        "topic1Descripe": 'Introduction to CSTR, DataCite, and ORCID persistent identifiers',
        "topic2Descripe": 'Mechanisms, policies and key technologies to support the interconnection of science and technology resource identification for open scientific data',
        "topic3Descripe": 'Typical Use Cases of Science Data Centers',
        "schedule": 'Workshop Agenda',
        "day1": 'DAY1',
        "date1": 'October 17, Tuesday',
        'tuesday': 'Tuesday',
        'tbd': '',
        'content1': 'Welcome and introduction speech',
        "content2": 'Global Open Identifier: Alignment and interoperability across PIDs',
        "name1": "Jia Liu",
        "name2": "Xin Li",
        "name3": "Jianhua Liu",
        "name4": "Estelle Cheng",
        "name5": "Chen Xin",
        "name6": "Xiaoli Chen",
        "name7": "Lulu Jiang",
        "name8": "Yan Xi",
        "content3": 'Connecting Research, Advancing Knowledge: global infrastructure efforts',
        "content4": 'Invited talk from National Tibetan Plateau Data Center',
        "content5": 'Introduction to Wanfang consortium',
        'MoreImpact': 'More Impact, Less Effort: Laying the Foundation for research data management through PIDs like ORCiD',
        "Implementing": 'Signing of  CSTR & DataCite',
        "InvitedTalk": 'Invited talk from Scientific Data Center of CAS',
        "Review": 'Coffee Break',
        "report": 'Invited talk from National Space Science Data Center',
        "report1": 'Invited talk from National Cryosphere Desert Data Center',
        "report2": 'Invited talk from National Astronomical Data Center',
        "report3": 'Moderated discussion',
        "day2": "DAY2",
        "date2": " October 18, Wednesday",
        "process": "Implementing FAIR Workflows",
        "dayReport": "Invited talk from Science Data Bank ",
        "dayReport2": "Invited talk from  China National Genebank",
        "dayReport3": "Invited talk from National Geological Archives of China",
        "dayReport4": "Science Data and Science Data Paper Publishing",
        "dayReport5": "Review and wrap up",
        "afternoon": "Afternoon",
        "DataCite": "DataCite APAC EG",
        "cstr": "CSTR Community aims to promote the establishment of a global science and technology resource identification architecture that can trace global influence, cross disciplines, cross regions, and cross platforms. This will enable rapid positioning and acquisition of resources worldwide and serve as the digital foundation for open science. The CSTR identifier has been accepted as one of the IANA international standards, and it has contributed to scientific research innovation. CSTR provides unique identification services for global scientific data, papers, scientific institutions, researchers, scientific instruments, patents, and other scientific and technological resources. DataCite is a global community that shares the vision of opening and connecting research outputs and resources to promote inter- and cross-disciplinary reuse. DataCite has been working with organizations in China and the wider APAC region to encourage the adoption of open PIDs and metadata workflows in the research data management process.",
        "datacite": "DataCite and Common Science and Technology Resource Identifier (CSTR) are co-organizing an in-person workshop in Beijing, China, bringing together stakeholders in the Open science and research data management communities to explore the role of persistent identifiers (PIDs) in local and global contexts, demonstrate implementation cases, and discuss recent developments in the global PID ecosystem.",
        "participate": "How to participate",
        "methods1": "Offline Participation send email to",
        "methods2": "Online Participation",
        "methods3": "Register here",
        "theme": "Join the forthcoming International Workshop on Open Science Identifier starting on Tuesday 17 October 2023"

    }

}
export default lang